import React, { lazy, Suspense } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AppProvider } from "./context/AppContext";
import { CuratorProvider } from "./context/CuratorContext";
import DashboardLayout from "./components/layout/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Analysis from "./pages/Analysis";
import Settings from "./pages/Settings";
import Scorer from "./pages/Scorer";
import TradingViewPage from "./pages/TradingView";
import BulkReview from "./pages/BulkReview";
import Annotate from "./pages/Annotate";
import Audit from "./pages/Audit";
import LandingRedirect from "./components/LandingRedirect";

const FractalExplorer = lazy(() => import("./pages/FractalExplorer").catch(() => ({ default: () => <div style={{ padding: '2rem', color: '#a1a1aa' }}>Fractal Explorer module not loaded</div> })));
const Intelligence = lazy(() => import("./pages/Intelligence").catch(() => ({ default: () => <div style={{ padding: '2rem', color: '#a1a1aa' }}>Intelligence module not loaded</div> })));
const HealthDashboard = lazy(() => import("./pages/HealthDashboard").catch(() => ({ default: () => <div style={{ padding: '2rem', color: '#a1a1aa' }}>Health Dashboard module not loaded</div> })));
const AutoTrader = lazy(() => import("./pages/AutoTrader").catch(() => ({ default: () => <div style={{ padding: '2rem', color: '#a1a1aa' }}>Auto Trader module not loaded</div> })));
const Indicators = lazy(() => import("./pages/Indicators").catch(() => ({ default: () => <div style={{ padding: '2rem', color: '#a1a1aa' }}>Indicators module not loaded</div> })));
const IngestionDashboard = lazy(() => import("./pages/IngestionDashboard").catch(() => ({ default: () => <div style={{ padding: '2rem', color: '#a1a1aa' }}>Ingestion module not loaded</div> })));
const Terminal = lazy(() => import("./pages/Terminal").catch(() => ({ default: () => <div style={{ padding: '2rem', color: '#a1a1aa' }}>Terminal module not loaded</div> })));
const Report = lazy(() => import("./pages/Report").catch(() => ({ default: () => <div style={{ padding: '2rem', color: '#a1a1aa' }}>Report module not loaded</div> })));
const Learning = lazy(() => import("./pages/Learning").catch(() => ({ default: () => <div style={{ padding: '2rem', color: '#a1a1aa' }}>Learning module not loaded</div> })));
const DemoFlow = lazy(() => import("./pages/DemoFlow").catch(() => ({ default: () => <div style={{ padding: '2rem', color: '#a1a1aa' }}>Demo Flow module not loaded</div> })));

function App() {
  return (
    <AppProvider>
      <CuratorProvider>
        <BrowserRouter>
          <DashboardLayout>
            <Suspense fallback={<div style={{ padding: '2rem', color: '#a1a1aa' }}>Loading...</div>}>
              <Routes>
                <Route path="/" element={<LandingRedirect />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/analysis/:projectId" element={<Analysis />} />
                <Route path="/analysis" element={<Analysis />} />
                <Route path="/bulk-review" element={<BulkReview />} />
                <Route path="/tradingview" element={<TradingViewPage />} />
                <Route path="/scorer" element={<Scorer />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/fractal" element={<FractalExplorer />} />
                <Route path="/intelligence" element={<Intelligence />} />
                <Route path="/health" element={<HealthDashboard />} />
                <Route path="/auto-trader" element={<AutoTrader />} />
                <Route path="/indicators" element={<Indicators />} />
                <Route path="/annotate" element={<Annotate />} />
                <Route path="/audit" element={<Audit />} />
                <Route path="/ingestion" element={<IngestionDashboard />} />
                <Route path="/terminal" element={<Terminal />} />
                <Route path="/terminal/:sector" element={<Terminal />} />
                <Route path="/report" element={<Report />} />
                <Route path="/learning" element={<Learning />} />
                <Route path="/demo" element={<DemoFlow />} />
              </Routes>
            </Suspense>
          </DashboardLayout>
          <Toaster position="bottom-right" theme="dark" />
        </BrowserRouter>
      </CuratorProvider>
    </AppProvider>
  );
}

export default App;
